import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import * as serviceWorker from "./serviceWorker";
//for pma Cover letter
import "../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
/**common css files */
import "./index.css";
import "views/Pma/PmaEditor/CommonEditor/ivyprestoFonts.scss";

/**Client */
import { Provider } from "react-redux";
import { store } from "./_store";
import disableConsoleLogs from "common/utils/DisableConsoleLogs";
import { webpack5Polyfills } from "common/utils/webpack5.util";
import PrintPMA from "views/Pma/PmaEditor/PrintPMA";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { SnackbarProvider } from "notistack";
import theme from "./theme";

import "./assets/scss/index.scss";

/**Disable console logs */
disableConsoleLogs();
/**Add webpack 5 browser polyfills (matches main index.js) */
webpack5Polyfills();

const container = document.getElementById("pma-print-root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <SnackbarProvider maxSnack={3}>
          <Router>
            <Routes>
              <Route
                element={<PrintPMA />}
                path="/printpma/:listgenUserID/:mailproid"
              />
              <Route
                element={<PrintPMA />}
                path="/pdfprintversion/:listgenUserID/:mailproid"
              />
            </Routes>
          </Router>
        </SnackbarProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
